import { Component, h, Prop, Element } from '@stencil/core';
import { Logger } from '../../../global/_types';

@Component({
  tag: 'cms-loading',
  styleUrl: 'cms-loading.scss',
  shadow: true,
})

export class CmsLoading {
  @Element() host: HTMLElement;

  @Prop() config: string | CmsLoadingConfig;
  @Prop() debug: boolean = false;

  /* Config */
  private options: CmsLoadingConfig;

  private logger: Logger;

  // Lifecycle
  componentWillLoad() {
    this.logger = new Logger(this.debug, 'CmsLoading');

    this.options =
      typeof (this.config) === 'string' ?
      JSON.parse(this.config) as CmsLoadingConfig :
      this.config;
  }

  componentDidLoad() {
    this.logger.trace('CmsLoading loaded');
  }

  // Render
  render() {
    return (
      <div class="cms-loading">
        <div class="loader-text" innerHTML={this.options.label} />
        <div class="loader-dots-wrapper"><div class="loader-dots"/></div>
      </div>
    );
  }

}

export interface CmsLoadingConfig {
  label: string;
}
